import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class AIGatwayService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }
  // Speech to text
  getContentAudio(id: string) {
    return this.get(`/v2/ai-task/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/AIGatway.service.ts